// src/modules/app-views/_apps/appsindico/units/pages/Document/tabs/AgreementsTab.jsx
// *******************************************************************************
// AGREEMENTS TAB
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Row, Col, Card } from 'antd';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import SimpleSwitch from 'components/SimpleComponents/SimpleSwitch';
import SimpleTextArea from 'components/SimpleComponents/SimpleTextArea';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const AgreementsTab = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <>
      <Card size="small" title={translateX('fire_brigade')} className="mb-3">
        <Row gutter={ROW_GUTTER}>
          <Col xs={24} sm={12}>
            <SimpleSwitch
              name={['fireBrigade', 'specialAttention']}
              label="special_attention"
            />
          </Col>
          <Col xs={24} sm={12}>
            <SimpleSwitch
              name={['fireBrigade', 'emergencyCase']}
              label="emergency_case"
            />
          </Col>
        </Row>
        <Row gutter={ROW_GUTTER}>
          <Col xs={24}>
            <SimpleTextArea
              name={['fireBrigade', 'observations']}
              label="observations"
              rows={2}
            />
          </Col>
        </Row>
      </Card>

      <Card size="small" title={translateX('agreements')}>
        <Row gutter={ROW_GUTTER}>
          <Col xs={24} sm={8}>
            <SimpleSwitch
              name={['agreements', 'declaration']}
              label="agreement_declaration"
            />
          </Col>
          <Col xs={24} sm={8}>
            <SimpleSwitch
              name={['agreements', 'commitment']}
              label="agreement_commitment"
            />
          </Col>
          <Col xs={24} sm={8}>
            <SimpleSwitch
              name={['agreements', 'aware']}
              label="agreement_aware"
            />
          </Col>
        </Row>
      </Card>
    </>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default AgreementsTab;
